<div container>
  <div class="section3__headline__container d-flex flex-column flex-lg-row align-items-lg-center gap-4 gap-lg-5">
    <div class="headline-image align-self-lg-start mt-lg-2">
      <picture [data]=" {
        image: 'benefits-of-knowing/section3-icon',
        webp: true,
        altext: 'A care team',
        format: '',
        width: '141',
        height: '82',
        mobile: false,
        classes: 'img-fluid',
      }"></picture>
    </div>
    <div class="headline-text-box">
      <h2>Find the right care team</h2>
      <p class="mb-0">
        Endocrinologists and diabetes educators are diabetes experts. Talk to a
        doctor to help guide you or your loved one on the best ways to manage
        type 1 diabetes and help assemble the right care team.
      </p>
      <h3 class="mt-5">It's never too early to start the conversation</h3>
      <p class="mb-4">There is a significant family risk factor with T1D, so if you or a relative are diagnosed with
        T1D, ask your doctor about the possible benefits of regular or repeated autoantibody screening for your loved
        ones. However, even if you don’t have a family history, it’s never too early to ask a doctor about screening.
      </p>
    </div>
  </div>
  <div class="section3__cards__container d-flex flex-column flex-lg-row">
    <div class="card card--orange bg-white d-flex flex-column flex-lg-row align-items-lg-center">
      <div class="card__image card__image--1 flex-shrink-0 align-self-baseline">
        <picture [data]=" {
        image: 'benefits-of-knowing/card-1-image',
        webp: true,
        altext: 'A microscope',
        format: '',
        width: '117',
        height: '126',
        mobile: false,
        classes: 'img-fluid',
      }"></picture>
      </div>
      <div class="card__text-box">
        <h3>Breakthrough T1D’s Early Detection Program</h3>
        <p class="mb-4">
          Early Detection is Breakthrough T1D’s education and awareness program
          for type 1 diabetes screening and monitoring. Find out more about the
          importance of early detection, how and where to get screened, and what
          to do after you've received your results.
        </p>
        <div class="card--1__button">
          <div global-button [buttonData]="{
              buttonLabel: 'Visit BreakthroughT1D.org',
              buttonUrl: 'https://www.breakthrought1d.org/early-detection/',
              openInNewTab: true,
              buttonIcon: 'right-icon',
              interstitial: true
            }"></div>
        </div>
      </div>
    </div>
    <div class="card card--yellow bg-white d-flex flex-column flex-lg-row align-items-lg-center">
      <div class="card__image card__image--2 flex-shrink-0 align-self-baseline">
        <picture [data]=" {
        image: 'benefits-of-knowing/card-2-image',
        webp: true,
        altext: 'A network of people',
        format: '',
        width: '105',
        height: '103',
        mobile: false,
        classes: 'img-fluid',
      }"></picture>
      </div>
      <div class="card__text-box">
        <h3>Ask the Experts Program</h3>
        <p class="mb-4">
          A group of type 1 diabetes experts are available to offer support and
          answer questions about early screening and
          <br class="d-none d-lg-block" />what the results mean. They can also
          <br class="d-none d-lg-block" />provide advice about a plan for
          <br class="d-none d-lg-block" />monitoring and future testing.
        </p>
        <div class="card--2__button">
          <div global-button [buttonData]="{
              buttonLabel: 'Visit AsktheExperts.org',
              buttonUrl: 'https://www.asktheexperts.org',
              openInNewTab: true,
              buttonIcon: 'right-icon',
              interstitial: true
            }"></div>
        </div>
      </div>
    </div>
  </div>
</div>